import { NavigateOptions, To } from 'react-router-dom'

type AppRouteItem = {
    pathname: To
    options?: NavigateOptions
}

type AppRoute = {
    [key: string]: AppRouteItem
}

const APP_ROUTES: AppRoute = {
    HOME: {
        pathname: ''
    },
    MY_ACCOUNT: { pathname: "/my-account" },
    HOME_HISTORY: { pathname: "/home-history" },
    WHY_SIMPLER_HOME: { pathname: "/why-simpler-home" },
    MESSAGE_FROM_TEAM: { pathname: "/message-from-team" },
    HOME_MAINTENANCE_GUIDE: { pathname: "/home-maintenance-guide" },
    FEATURE: { pathname: "/feature" },
    RESOURCES: { pathname: "/resources" },
    PREMIUM: { pathname: "/premium" },
    PROPERTY_PROFESSIONAL: { pathname: "/property-professional" },
    THANK_YOU: { pathname: "/thank-you" },
    // Footer pages
    CONTACT: { pathname: "/contact" },
    CAREERS: { pathname: "/careers" },
    PRESS: { pathname: "/press" },
    BLOG: { pathname: "/blog" },
    TERMS_PRIVACY: { pathname: "/terms-privacy" },
    DO_NOT_SELL: { pathname: "/do-not-sell" },
    LEGAL: { pathname: "/legal" },
    TRUE_COST_GUIDE: { pathname: "/true-cost-guide" },
    LICENSING_REQUIREMENTS: { pathname: "/licensing-requirements" },
    // Browse pages
    BROWSE_STATES: { pathname: "/browse-states" },
    BROWSE_CITIES: { pathname: "/browse-cities" },
    // Admin routes
    ADMIN: { pathname: "/admin" },
    ADMIN_LOGIN: { pathname: "/admin/login" },
    ADMIN_DASHBOARD: { pathname: "/admin/dashboard" },
    ADMIN_USERS: { pathname: "/admin/users" },
    ADMIN_PROPERTIES: { pathname: "/admin/properties" },
    ADMIN_BOOKINGS: { pathname: "/admin/bookings" },
    ADMIN_REPORTS: { pathname: "/admin/reports" },
    ADMIN_SETTINGS: { pathname: "/admin/settings" },
    ADMIN_APN_UPLOAD: { pathname: "/admin/apn-upload" },
    ANY: {
        pathname: '*'
    }
}

export default APP_ROUTES
